export const FillManuallyOptionConstants = {
  ManualOptionValue: 'manual',
};
